// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ib-0";
export var fileCarousel = "_ib-2";
export var removeFileButton = "_ib-1";